import localScaleManager from "../../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../../helpers/tweensConfigs";
import SideMenuOverlay from "../sideMenuOverlay";

export class Chat {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.tableInfo = table.tableInfo;
    this.showChatMenu = false;
    this.pointerDown = false;

    this.chatIcon = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "chat-icon")
      .setOrigin(0);
    this.margin = 0;
    this.chatIcon.setInteractive({ cursor: "pointer" });
    this.chatIcon.on("pointerdown", this.onPointerDown, this);
    this.chatIcon.on("pointerup", this.onPointerUp, this);

    this.registryName = "showChatMenu";
    this.scene.registry.set(this.registryName, false);
    this.overlay = new SideMenuOverlay(scene, this.registryName);
    this.isChatBlocked = false;
  }
  onPointerDown() {
    this.pointerDown = true;
  }
  onPointerUp() {
    if (!this.isChatBlocked) {
      if (this.scene.isSceneObjectsInteractive && this.pointerDown) {
        this.showChatMenu = true;
        this.scene.registry.set(this.registryName, this.showChatMenu);
        this.overlay.show();
      }
      this.pointerDown = false;
    } else {
      this.scene.alertify.typeWarning("Text messaging has been disabled.");
    }
  }
  changePosition(x) {
    const initPosition =
      this.scene.gameWidth - this.chatIcon.displayWidth - this.margin;
    this.chatIcon.setX(x + initPosition);
    this.overlay.reposition();
  }
  scrollTo(positionX) {
    const initPosition =
      this.scene.gameWidth - this.chatIcon.displayWidth - this.margin;
    this.scene.tweens.add({
      targets: this.chatIcon,
      x: initPosition + positionX,
      duration: tweenConfigs.camera.duration,
      ease: tweenConfigs.camera.ease,
      onComplete: () => {
        this.updateTable();
        this.overlay.reposition();
      },
    });
  }
  block(status) {
    this.isChatBlocked = !status;
  }
  hide() {
    if (!this.showChatMenu) return;
    this.scene.registry.set(this.registryName, false);
    this.overlay.hide();
    this.showChatMenu = false;
  }
  /**
   * tamame object hayii k az table in object(this.table) estefade mikonn bayad update shavand..
   */
  updateTable() {
    this.table = this.scene.getVisitedTable();
    this.tableInfo = this.table.tableInfo;
  }
  /**
   * @param width {number} table width
   * @param height {number} table height
   */
  positionControls(width, height) {
    this.margin = this.scene.header.menu.menuMargin;
    let iconSize = Math.min(width / 11, height / 11);
    localScaleManager.scaleSprite(
      this.chatIcon,
      iconSize,
      iconSize,
      0,
      1,
      true
    );
    this.chatIcon.setPosition(
      this.scene.gameWidth - this.chatIcon.displayWidth - this.margin,
      this.scene.gameHeight - this.margin * 10
    );

    this.overlay.positionControls();
  }
  /**
   * @param width {number} table width
   * @param height {number} table height
   */
  reposition(width, height) {
    this.margin = this.scene.header.menu.menuMargin;
    this.chatIcon.setPosition(
      this.scene.gameWidth - this.chatIcon.displayWidth - this.margin,
      this.scene.gameHeight - this.margin * 10
    );

    this.overlay.reposition();
  }
}
